import React from "react";
import { Col, Form, Row, Spinner } from "react-bootstrap";
import { Formik } from "formik";
import DatePickercomp from "../../components/DatePicker";
import MyInput from "../../components/MyInput";
import { BsUpload } from "react-icons/bs";
import { Helmet } from "react-helmet";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import {
  getAllBankListForDropdown,
  getSingleAccountDetailsById,
  postAccountDetails,
  updateAccountDetails,
} from "../../services/contractorApi";
import { addCreditor, updateCreditor } from "../../services/contractorApi";
import { ViewTransaction } from "../MasterDataManagement/AccountManagement/ViewTransaction";
import { getAdminAllHREmployees } from "../../services/authapi";
// import { bankToBankTransferSchema } from "../../utils/formSchema";
import { useEffect } from "react";

import CardComponent from "../../components/CardComponent";
import { getAllAccountDetails } from "../../services/contractorApi";
import { useSelector } from "react-redux";
import ConfirmAlert from "../../components/ConfirmAlert";
import { getAllPaymentModes } from "../../services/contractorApi";
import Select from "react-select";
import { addBankToBankTransfer } from "../../services/contractorApi";
import {
  addBanktobanktransferSchema,
  CashdepositWithdrawSchema,
} from "../../utils/formSchema";
import { getallbanktobankTransaction } from "../../services/authapi";
import { updateBankToBankTransfer } from "../../services/contractorApi";
import { useState } from "react";
import { date } from "yup";

import { onlyDecimalKey, handleDecimalPaste } from "../../utils/helper";
const AddCashWithdrawDeposit = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  const [search, setSearch] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [pageNo, setPageNo] = useState(1);
  const [creditorsdata, setCreditorData] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [showAlert, setShowAlert] = useState(false);
  const [userAccount, setUserAccount] = useState([]);
  const [error, setError] = useState("");

  const user_id = useSelector((state) => state.auth.user.id);
  const user_type = useSelector((state) => state.auth.user.user_type);
  const [firmBankAccount, setFirmBankAccount] = useState([]);
  const [edit, setEdit] = useState([]);

  const [accountNumber, setAccountNumber] = useState("");

  const [fromHolderName, setFromHolderName] = useState("");
  const [toHolderName, setToHolderName] = useState("");
  const [amountError, setAmountError] = useState("");
  const [filteredFirmBankAccount, setFilteredFirmBankAccount] = useState([]);
  const [filteredUserAccount, setFilteredUserAccount] = useState([]);
  const [bankBalance, setbankBalance] = useState("");
  const [amountErrorMessage, setAmountErrorMessage] = useState("");
  const [cashbalance, setCashBalance] = useState("");

  // const type = searchParams.get("type") || null;
  const type = "expl";
  const { t } = useTranslation();

  const fetchAllHrCrediotrsData = async () => {
    const res = await getAdminAllHREmployees({
      search,
      pageSize,
      pageNo,
      forAccount: true,
      isCreditor: true,
    });
    if (res.status) {
      // const data = res.data.filter((item) => item.account_number);
      setCreditorData(
        res.data.map((item) => {
          return {
            value: item.id,
            label: `${item.name} - ${item.bank_name} - ₹${item.closing_balance}`,
            account_number: item.account_number,
            closing_balance: item.closing_balance,
          };
        })
      );

      setTotalData(res?.pageDetails?.total);
    } else {
      setRows([]);
      setTotalData(0);
    }
    setIsLoading(false);
  };

  const fetchAllHrEmployeesData = async () => {
    const res = await getAdminAllHREmployees({
      search,
      pageSize,
      pageNo,
      forAccount: true,
      isDropdown: true,
    });
    if (res.status) {
      const data = res.data.filter(
        (item) =>
          item.account_number !== null &&
          item.bank_name !== null &&
          item.bank_name !== ""
      );
      setUserAccount(
        data.map((item) => {
          return {
            value: item.id,
            label: (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span>{`${item.name} - ${item.bank_name}- ₹${item.closing_balance} `}</span>
              </div>
            ),
            account_number: item.account_number,
            closing_balance: item.closing_balance,
            fund_limit: item.fund_limit,
          };
        })
      );

      setTotalData(res?.pageDetails?.total);
    } else {
      setUserAccount([]);
      setTotalData(0);
    }
    setIsLoading(false);
  };

  const fetchAllBankData = async () => {
    const res = await getAllAccountDetails(
      search,
      pageSize,
      pageNo,
      user_id,
      user_type
    );
    setIsLoading(true);
    if (res.status) {
      setFirmBankAccount(
        res.data.map((item) => ({
          value: item.id,
          label: `${item.account_holder_name} - ${item.bank_name} - ₹${item.closing_balance}`,
          account_number: item.account_number,
          closing_balance: item.closing_balance,
          bank_name: item.bank_name,
        }))
      );
      setCashBalance(
        res.data.find((item) => item.bank_name === "Cash Account")
          ?.closing_balance || 0
      );

      setTotalData(res?.pageDetails?.total);
    } else {
      setRows([]);
      setTotalData(0);
    }
    setIsLoading(false);
  };

  const transaction_type = [
    { value: "W", label: "Cash Withdraw " },
    { value: "D", label: " Cash Deposit " },
  ];

  const transactionFor = [
    { value: "F", label: " Fund" },
    { value: "S", label: " Stock" },
  ];
  const from_account = [
    { value: "UA", label: "User Bank Account" },
    { value: "CA", label: "Creditor Bank Account" },
    { value: "BA", label: " Company Bank Account" },
  ]; // Account Type

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    console.log("values", values);
    if (!values) return [];

    const formData = new FormData();

    formData.append("transaction_type", values.transaction_type);
    formData.append("date", values.date);
    formData.append("amount", values.amount);
    formData.append("remark", values.remark || "");
    formData.append("transaction_id", values.transaction_id);

    formData.append("user_id", user_id);
    formData.append("account_type", values.account_type);
    formData.append("transaction_for", values.transaction_for || "");

    // if (edit?.account_id) {
    //   formData.append("account_transfer_id", id);

    // }
    // if (edit?.id) {
    //   formData.append("user_transfer_id", edit?.id);
    // }

    if (values.transaction_type === "W") {
      formData.append("from_account", values.from_account);
    } else if (values.transaction_type === "D") {
      formData.append("to_account", values.from_account);
    }

    formData.append("user_id", user_id);
    if (edit?.account_id) {
      formData.append("account_transfer_id", id);
      // formData.append("creation_date", edit?.created_at);
    }
    if (edit?.id) {
      formData.append("user_transfer_id", edit?.id);
    }
    const res =
      edit?.account_id || edit?.id
        ? await updateBankToBankTransfer(formData, edit?.account_id)
        : await addBankToBankTransfer(formData);

    if (res.status === true) {
      toast.success(res.message);
      navigate(-1);

      resetForm();
      // alert("yo")
    } else {
      toast.error(res.message);
      setShowAlert(false);
    }
    setSubmitting(false);
  };
  const fetchallbankTransactions = async () => {
    const params = {
      accounts_transfer_id: id,
      is_cash_transaction: true,
    };
    const res = await getallbanktobankTransaction(params);
    if (res.status) {
      // const data = res.data.filter((item) => item.account_number);
      setEdit(res.data[0]);

      if (res?.data[0]?.transaction_type === "W") {
        setbankBalance(res?.data[0]?.to_user_balance);
      }
      setAccountNumber(
        res?.data[0]?.to_user_account_number ||
          res?.data[0]?.from_user_account_number
      );
      // setbankBalance(res?.data[0]?.bank_balance);
      // setToHolderName(
      //   res.data[0].to_user_account_number || res.data[0].to_bank_account_number
      // );

      setTotalData(res?.pageDetails?.total);
    } else {
      setRows([]);
      setTotalData(0);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (id !== "new") {
      fetchAllHrEmployeesData();
      fetchallbankTransactions();

      fetchAllBankData();
      fetchAllHrCrediotrsData();
    }
  }, [id]);

  return (
    <>
      <Helmet>
        <title>
          {id == "new" ? "Create New" : "Update "} Account · CMS Electricals
        </title>
      </Helmet>

      <Col md={12} data-aos={"fade-up"} data-aos-delay={200}>
        <CardComponent
          showCardHeader={true}
          showBackButton={true}
          className={type === "details" && "after-bg-light"}
          title={`${
            type === "details"
              ? t("View")
              : (edit?.account_id !== undefined && edit?.account_id !== null) ||
                (edit?.id !== undefined && edit?.id !== null)
              ? t("Update")
              : t("Add ")
          } ${t("Cash Withdrawal Deposit")}`}
        >
          {/* <ViewTransaction /> */}

          <Formik
            enableReinitialize={true}
            initialValues={{
              transaction_type: edit?.transaction_type || "",
              account_type: edit?.account_type || "",
              from_account: edit?.user_id || "",
              date:
                edit?.bank_txn_date || new Date().toISOString().slice(0, 10),
              amount: edit?.bank_amount || "",
              remark: edit?.remark || "",
              transaction_id: edit?.bank_txn_id || "",
              transaction_for:
                edit?.transaction_category === "Fund"
                  ? "F"
                  : edit?.transaction_category === "Stock"
                  ? "S"
                  : "",
            }}
            validationSchema={CashdepositWithdrawSchema}
            onSubmit={handleSubmit}
          >
            {(props) => (
              <Form onSubmit={props.handleSubmit}>
                <Row className="g-3">
                  {/* Transaction Type */}
                  <Form.Group as={Col} md={4}>
                    <Form.Label>
                      Transaction Type <span className="text-danger">*</span>
                    </Form.Label>
                    <MyInput
                      name="transaction_type"
                      formikProps={props}
                      customType="select"
                      isDisabled={edit?.id}
                      className="cursor-pointer"
                      selectProps={{ data: transaction_type }}
                      onChange={(option) => {
                        const value = option?.value || "";
                        props.setFieldValue("transaction_type", value);
                        if (value === "W") {
                          props.setFieldValue("remark", "Cash Withdrwal");
                        } else {
                          props.setFieldValue("remark", "Cash Deposit");
                        }

                        // Always reset form fields and state

                        if (!edit) {
                          props.setFieldValue("from_account", "");
                          props.setFieldValue("to_account", "");
                          setFromHolderName("");
                          setToHolderName("");
                          setAmountError("");
                          setFilteredFirmBankAccount([]);
                          setFilteredUserAccount([]);

                          setAccountNumber("");
                        }
                      }}
                    />
                  </Form.Group>

                  {/* From Account */}

                  <Form.Group as={Col} md={4}>
                    <Form.Label>
                      Account Type <span className="text-danger">*</span>
                    </Form.Label>
                    <MyInput
                      name="account_type"
                      formikProps={props}
                      isDisabled={edit?.id}
                      customType="select"
                      selectProps={{ data: from_account }}
                      onChange={(option) => {
                        const value = option?.value || "";

                        props.setFieldValue("account_type", value);

                        if (value === "CA") {
                          fetchAllHrCrediotrsData();
                        }
                        if (value === "UA") {
                          fetchAllHrEmployeesData();
                        }
                        if (value === "BA") {
                          fetchAllBankData();
                        }
                      }}
                    />
                  </Form.Group>

                  <Form.Group as={Col} md={4}>
                    <Form.Label>
                      Account list <span className="text-danger"> *</span>
                    </Form.Label>
                    <MyInput
                      name="from_account"
                      formikProps={props}
                      isDisabled={edit?.id}
                      customType="select"
                      selectProps={{
                        data:
                          props?.values?.account_type == "CA"
                            ? creditorsdata
                            : props?.values?.account_type == "UA"
                            ? userAccount
                            : props?.values?.account_type == "BA"
                            ? // yaha BA + W condition handle
                              props?.values?.transaction_type === "W"
                              ? firmBankAccount?.filter(
                                  (item) =>
                                    item.bank_name !== "Cash Account"
                                )
                              : firmBankAccount
                            : [],
                      }}
                      onChange={(option) => {
                        props.setFieldValue(
                          "from_account",
                          option?.value || ""
                        );
                        setAccountNumber(option?.account_number || "");
                        setbankBalance(option?.closing_balance || 0);
                      }}
                    />
                  </Form.Group>

                  {/* Auto Filled From Holder */}
                  <Form.Group as={Col} md={4}>
                    <Form.Label>Account Number</Form.Label>
                    <Form.Control
                      name="from_account_holder_number"
                      isDisabled={edit?.id}
                      type="text"
                      value={accountNumber}
                      readOnly
                      placeholder="Account Number"
                    />
                  </Form.Group>

                  {/* Transaction ID  */}
                  <Form.Group as={Col} md={4}>
                    <Form.Label>Transaction Id</Form.Label>
                    <MyInput
                      name="transaction_id"
                      type="text"
                      placeholder="Enter Transaction Id"
                      formikProps={props}
                      onChange={(e) =>
                        props.setFieldValue("transaction_id", e.target.value)
                      }
                      isDisabled={true}
                    />
                  </Form.Group>

                  {props.values.transaction_type == "D" &&
                    props.values.account_type == "UA" && (
                      <Form.Group as={Col} md={4}>
                        <Form.Label>
                          Transaction for <span>*</span>{" "}
                        </Form.Label>
                        <MyInput
                          name="transaction_for"
                          formikProps={props}
                          disabled={edit?.id}
                          customType="select"
                          selectProps={{ data: transactionFor }}
                          onChange={(option) => {
                            props.setFieldValue(
                              "transaction_for",
                              option?.value || ""
                            );
                            console.log(
                              "Transaction for changed to",
                              option?.value
                            );
                          }}
                        />
                      </Form.Group>
                    )}

                  {/* Date */}
                  <Form.Group as={Col} md={4}>
                    <Form.Label>
                      {" "}
                      Transaction Date <span className="text-danger">*</span>
                    </Form.Label>
                    <DatePickercomp
                      name="date"
                      value={props.values.date}
                      sendDate={(date) => props.setFieldValue("date", date)}
                      isDisabled={edit?.id ? true : false}
                      onChange={(date) => {
                        const formattedDate = date?.toISOString().slice(0, 10);
                        props.setFieldValue("date", formattedDate);
                      }}
                    />
                  </Form.Group>

                  {/* Amount */}
                  <Form.Group as={Col} md={4}>
                    <Form.Label>
                      Transfer Amount <span className="text-danger">*</span>
                    </Form.Label>
                    <MyInput
                      name="amount"
                      type="text" onKeyPress={onlyDecimalKey} onPaste={handleDecimalPaste} inputMode="decimal"
                      placeholder="Enter Amount"
                      formikProps={props}
                      onChange={(e) => {
                        const amount = e.target.value;
                        props.setFieldValue("amount", amount);

                        let errorMsg = "";

                        // 1️⃣ Withdrawal check
                        if (props.values.transaction_type === "W") {
                          if (parseFloat(amount) > parseFloat(bankBalance)) {
                            errorMsg = `Amount exceeds available balance of ₹${bankBalance}`;
                          }
                        }

                        // 2️⃣ Fund limit check for UA (non-withdrawal)
                        if (
                          props.values.transaction_type !== "W" &&
                          props.values.account_type === "UA"
                        ) {
                          const selectedAccount = userAccount.find(
                            (item) => item.value === props.values.from_account
                          );
                          const fund_limit = selectedAccount?.fund_limit || 0;
                          const balance = selectedAccount?.closing_balance || 0;
                          const remaining_limit = fund_limit - balance;

                          if (
                            parseFloat(amount) > parseFloat(remaining_limit)
                          ) {
                            errorMsg = `Amount exceeds available fund limit of ₹${fund_limit} and remaining limit is ₹${remaining_limit}`;
                          }
                        }

                        // 3️⃣ Cash balance check for BA / CA / UA (non-deposit)
                        if (
                          props.values.transaction_type == "D" &&
                          ["BA", "CA", "UA"].includes(props.values.account_type)
                        ) {
                          const selectedAccount = firmBankAccount.find(
                            (item) => item.value === props.values.from_account
                          );

                          // skip if bank_name is "Cash Account"
                          if (selectedAccount?.bank_name !== "Cash Account") {
                            if (parseFloat(amount) > parseFloat(cashbalance)) {
                              errorMsg = `Amount exceeds available cash balance of ₹${cashbalance}`;
                            }
                          }
                        }

                        setError(errorMsg);
                      }}
                    />
                    <Form.Text className="text-danger">{error}</Form.Text>
                  </Form.Group>

                  {/* Remark */}
                  <Form.Group as={Col} md={14}>
                    <Form.Label>Remark / Narration</Form.Label>
                    <MyInput
                      name="remark"
                      customType="multiline"
                      placeholder="Enter Remark"
                      formikProps={props}
                      onChange={(e) =>
                        props.setFieldValue("remark", e.target.value)
                      }
                    />
                  </Form.Group>

                  {/* Attachment */}

                  {/* Submit */}
                  <Form.Group as={Col} md={12}>
                    <div className="mt-4 text-center">
                      <button
                        type={"submit"}
                        disabled={error}
                        className="shadow border-0 purple-combo cursor-pointer px-4 py-1"
                      >
                        submit
                        {/* <Spinner
                            animation="border"
                            variant="primary"
                            size="sm" /> */}
                      </button>

                      <ConfirmAlert
                        size={"sm"}
                        deleteFunction={props.handleSubmit}
                        hide={""}
                        show={""}
                        title={"Confirm UPDATE"}
                        description={"Are you sure you want to update this!!"}
                      />
                    </div>
                  </Form.Group>
                </Row>
              </Form>
            )}
          </Formik>
        </CardComponent>
      </Col>
    </>
  );
};

export default AddCashWithdrawDeposit;
